export const formatDateTime = (input) => {
    if (!input) return "";
  
    const date = new Date(input);
    if (isNaN(date)) return "N/A";
  
    const pad = (n) => n.toString().padStart(2, "0");
  
    const formatted = `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ` +
                      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  
    return formatted;
  };
  